module.exports = __webpack_public_path__ + "img/logo_后博.fa290113.png";